// Extra-activity management (add via "+", edit via chip action menu, remove
// via chip action menu / delete modal) is temporarily hidden from users
// pending clarification of the flow. The underlying data model, mutations,
// and modals stay in place — only the UI entry points are gated.
export const EXTRA_ACTIVITY_MANAGEMENT_ENABLED = false;
